const driverLicensePendingFilters = {
    MY_PENDING: 'MY_PENDING',
    EMPLOYEE_PENDING: 'EMPLOYEE_PENDING',
};

export default driverLicensePendingFilters;
